// extracted by mini-css-extract-plugin
export default {"blueWhite":"themes_blueWhite__k4yS2"};